import { TemplateKey } from "PFApp/constants/templates";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import useIsPermittedTo from "PFCore/helpers/use_is_permitted_to";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { FeatureFlag, PermissionRule } from "PFTypes";
import { useMemo } from "react";

import { useTemplate } from "./hooks";

const useIsAuditPlannerPermitted = () => {
  const { data: currentProfile } = useCurrentProfile();
  const auditEngagagementTemplate = useTemplate(TemplateKey.AuditEngagement);
  const auditRoleTemplate = useTemplate(TemplateKey.AuditRole);

  const isPermittedTo = useIsPermittedTo(currentProfile);
  const isEnabled = useIsFeatureEnabled();

  const auditPlannerAccess = useMemo(() => {
    if (!isEnabled(FeatureFlag.AuditPlanner)) {
      return false;
    }
    const engagementReadPermitted = auditEngagagementTemplate?.read_permitted;
    const roleReadPermitted = auditRoleTemplate?.read_permitted;
    const isAuditResourcer = isPermittedTo(PermissionRule.AuditResourcer);
    const isAuditApprover = isPermittedTo(PermissionRule.AuditApprover);
    return (engagementReadPermitted || roleReadPermitted) && (isAuditResourcer || isAuditApprover);
  }, [
    isPermittedTo,
    isEnabled,
    auditRoleTemplate?.read_permitted,
    auditEngagagementTemplate?.read_permitted
  ]);

  return auditPlannerAccess;
};

export default useIsAuditPlannerPermitted;
